module.exports = __webpack_public_path__ + "img/cupra-header.89d677f5.png";